import React from 'react';

// react router dom
import { Routes, Route, useLocation, Outlet } from 'react-router-dom';

// framer motion
import { AnimatePresence } from 'framer-motion';

// pages
import Header from './layout/Header';
import Index from './pages/Index';
import About from './pages/About';
import Contact from './pages/Contact';
import Feedback from './pages/Feedbacks/Feedback'; 
import Stations from './pages/Stations';
import Milestone from './pages/AboutSub/Milestone';
import Footer from './layout/Footer';
import CustomScrollbar from './components/CustomScrollbar';
import News from './pages/AboutSub/News';
import Solutions from './pages/Solutions';
import Franchise from './pages/Franchise';
import Benefits from './pages/Benefits';
import LegalDocumentsPage from './pages/LegalDocuments'; 
import AccountDeletion from './pages/AccountDelection';
import StationDetails from './components/StationDetails';
import NewsDetails from '../markup/components/NewsDetails';
import FindStations from '../markup/pages/FindStation/Findstation';
import ResetPassword from './pages/auth/ResetPassword'; 
import AnimatedPage from './components/AnimatedPage';

// --- LAYOUT WRAPPER ---
const ContentLayout = () => {
    return (
        <AnimatedPage>
            {/* (Index, About, etc.) renders here */}
            <Outlet /> 
        </AnimatedPage>
    );
};

const Markup = () => {
    const location = useLocation();

    return (
        <>
            <CustomScrollbar />

            <div className="main-wrapper">
                
                {/* STATIC HEADER  */}
                <Header type='navigation-1' />

                {/* 2. ANIMATED CONTENT AREA */}
                <AnimatePresence exitBeforeEnter>
                    {/* Key ensures React remounts the ContentLayout on URL change */}
                    <Routes location={location} key={location.pathname}>
                        
                        {/* Wrapper Route: Applies Animation to all children */}
                        <Route element={<ContentLayout />}>
                            
                            {/* Home */}
                            <Route path="/" element={<Index />} />

                            {/* Auth */}
                            <Route path="/benefits/password-reset" element={<ResetPassword />} />

                            {/* About */}
                            <Route path="/about" element={<About />} />
                            <Route path="/milestone" element={<Milestone />} />
                            <Route path="/news" element={<News />} />
                            <Route path="/about/news_details" element={<NewsDetails />} />

                            {/* Stations */}
                            <Route path="/stations" element={<Stations />} />
                            <Route path="/stations/station_details" element={<StationDetails />} />
                            <Route path="/station_details" element={<StationDetails />} /> 
                            <Route path="/finder" element={<FindStations />} />

                            {/* Solutions / Products */}
                            <Route path="/products" element={<Solutions />} />
                            <Route path="/solutions" element={<Solutions />} />
                            <Route path="/product/solutions" element={<Solutions />} />

                            {/* Franchise */}
                            <Route path="/franchise" element={<Franchise />} />

                            {/* Contact */}
                            <Route path="/contact" element={<Contact />} />

                            {/* Feedback */}
                            <Route path="/feedback" element={<Feedback />} />
                            <Route path="/web/feedback" element={<Feedback />} />

                            {/* Benefits / Legal */}
                            <Route path="/benefits" element={<Benefits />} />
                            <Route path="/benefits/account-deletion" element={<AccountDeletion />} />
                            <Route path="/benefits/:key" element={<LegalDocumentsPage />} />

                            {/* Details */}
                            <Route path="/news_details" element={<NewsDetails />} />
                            
                        </Route> 


                    </Routes>
                </AnimatePresence>

                {/*  STATIC FOOTER  */}
                <Footer />
                
            </div>
        </>
    );
};

export default Markup;